import {
  eventAlerts,
  PostAlertsRequest,
  PostReadRequest,
  PostSubscriptionRequest,
  SourceType,
} from '@api';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const postAlerts = (body: PostAlertsRequest) =>
  wretchRequest(eventAlerts.postAlerts.path, {
    method: 'post',
    body,
    schema: eventAlerts.postAlerts.schema,
  });

export const postSubscription = (body: PostSubscriptionRequest) =>
  wretchRequest(eventAlerts.postSubscriptions.path, {
    method: 'post',
    body,
  });

export const getSubscription = (sourceId: string, sourceType: SourceType) =>
  wretchRequest(eventAlerts.getSubscriptions.path(sourceId, sourceType), {
    schema: eventAlerts.getSubscriptions.schema,
  });

export const postRead = (body: PostReadRequest) =>
  wretchRequest(eventAlerts.postRead.path, {
    method: 'post',
    body,
  });

export const postReadAll = () =>
  wretchRequest(eventAlerts.postReadAll.path, {
    method: 'post',
  });
